import type { CSSProperties } from 'react';

import { StructureCanvasHelper } from '../canvas';
import type { LayoutLine, Rect } from '../layout';

interface OwnershipLinePathsProps {
  lines: ReadonlyArray<LayoutLine>;
  bounds: Readonly<Rect>;
  isHighlighted: boolean;
}

// The image export copies the svg's resolved colour but keeps its paths' styles as written, and a
// CSS variable inside them doesn't resolve in every browser, so the paths draw in the svg's colour.
const lineStyle: CSSProperties = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const OwnershipLinePaths = ({
  lines,
  bounds,
  isHighlighted,
}: OwnershipLinePathsProps) => (
  <svg
    aria-hidden="true"
    width={bounds.width}
    height={bounds.height}
    viewBox={`${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`}
    style={{
      position: 'absolute',
      left: bounds.x,
      top: bounds.y,
      overflow: 'visible',
      color: isHighlighted
        ? 'var(--pf-color-soft-pearl-700)'
        : 'var(--pf-color-soft-pearl-400)',
    }}
  >
    {lines.map((line) => (
      <path
        key={line.id}
        d={line.d}
        strokeDasharray={StructureCanvasHelper.LINE_DASH[line.kind]}
        style={lineStyle}
      />
    ))}
  </svg>
);

export { OwnershipLinePaths };
